
import { EventManager } from './EventManager.js';

export default {
  data() {
      return {
        selectedPost: null,
      };
  },

  props: {
    menuData: {
      type: Array,
      default: function() {
        return [];
      },
    },
    topMenuData: {
      type: Array,
      default: function() {
        return [];
      },
    },
    currentId: {
      type: Number,
      default: -1,
    },
  },

  computed: {

  },

  watch: {

  },

  methods: {
    closeMenu: function() {
      EventManager.$emit('should-close-menu');
    },
    didSelectPost: function(post) {
      var self = this;

      if(post.children && post.children.length) {
        self.selectedPost = (self.selectedPost === post) ? null : post;
        return;
      }

      window.location.href = post.url;
    },
    didSelectParentPost: function(post) {
      var self = this;
      window.location.href = post.url;
    },

    enter(element) {
      var width = getComputedStyle(element).width;

      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      var height = getComputedStyle(element).height;

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
          element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    leave(element) {
      var height = getComputedStyle(element).height;

      element.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      requestAnimationFrame(() => {
          element.style.height = 0;
      });
    },
  },

  components: {

  },

  mounted() {

  },

  updated() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/PrimaryMenu.vue